<template>
  <!--====== APPIE HEADER PART START ======-->

  <div class=" navpad whitebackground">

    Hi 👋 <span><b>{{employeeprofile.name}}</b></span><br>
    {{employeeprofile.company}}



  </div>



  <!--====== APPIE HEADER PART ENDS ======-->
</template>

<script>

export default {



  data() {
    return {
      profile:'',
    }
  },
  created() {
    this.employeeprofile = JSON.parse(localStorage.getItem("profileData"));
  },


  methods: {


}}
</script>


